<template>
    <button type="button"
            class="btn btn-sm btn-default btn-with-icon btn-responsible"
            :class="{'is-responsible': isResponsible }"
            :disabled="!user.is_technician || project.is_completed"
            @click="setAsReponsible()">
        <i class="fa fa-star"></i>
    </button>
</template>
<script>
    export default {

        props: {
            user: {
                type: Object,
                required: true,
            },
            project: {
                type: Object,
                required: true,
            }
        },

        data(){
            return {
                isResponsible: this.user.invited.is_responsible
            }
        },

        methods: {
            setAsReponsible() {
                if(this.isResponsible) return;
                App.request().patch(`/projects/${this.project.slug}/work-team/${this.user.slug}/responsible`) .then(response => {
                    App.bus.$emit(`${this.project.slug}-responsible`, this.user);
                    Toast.success(`The ATT ${this.user.name} is the lead ATT of the Project.`);
                }).catch(errors => {
                    Toast.error('Whoops, looks like something went wrong!')
                })
            },
        },


        created() {
            App.bus.$on(`${this.project.slug}-responsible`, responsible => {
                this.isResponsible = (this.user.id == responsible.id)
            })
        }
    }
</script>
